import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { getSidebarNavItems } from './navigationConfig';
import ResponsiveLogo from './ResponsiveLogo';

const getSidebarIcon = (iconName) => {
  const iconClassName = 'w-[18px] h-[18px]';

  switch (iconName) {
    case 'dashboard':
      return (
        <svg className={iconClassName} fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h7v5H4V6zm9 0h7v8h-7V6zM4 13h7v5H4v-5zm9 3h7v2h-7v-2z" />
        </svg>
      );
    case 'description':
      return (
        <svg className={iconClassName} fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6M7 4h7l5 5v11a1 1 0 01-1 1H7a1 1 0 01-1-1V5a1 1 0 011-1z" />
        </svg>
      );
    case 'event':
      return (
        <svg className={iconClassName} fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a1 1 0 001-1V8a1 1 0 00-1-1H5a1 1 0 00-1 1v12a1 1 0 001 1z" />
        </svg>
      );
    case 'attendance':
      return (
        <svg className={iconClassName} fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" />
        </svg>
      );
    case 'grade':
      return (
        <svg className={iconClassName} fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6l8 4-8 4-8-4 8-4zm0 8v6m-6-3h12" />
        </svg>
      );
    case 'payments':
      return (
        <svg className={iconClassName} fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 7h16M4 11h16M5 5h14a1 1 0 011 1v12a1 1 0 01-1 1H5a1 1 0 01-1-1V6a1 1 0 011-1z" />
        </svg>
      );
    case 'folder':
      return (
        <svg className={iconClassName} fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 7a2 2 0 012-2h4l2 2h8a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2V7z" />
        </svg>
      );
    case 'library':
      return (
        <svg className={iconClassName} fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01" />
        </svg>
      );
    case 'book':
      return (
        <svg className={iconClassName} fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
        </svg>
      );
    case 'edit':
      return (
        <svg className={iconClassName} fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.5-7.5a2.121 2.121 0 113 3L12 17l-4 1 1-4 8.5-8.5z" />
        </svg>
      );
    case 'science':
      return (
        <svg className={iconClassName} fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 3h6m-1 0v5l4 7a2 2 0 01-1.7 3H7.7A2 2 0 016 15l4-7V3" />
        </svg>
      );
    case 'exam':
      return (
        <svg className={iconClassName} fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
        </svg>
      );
    case 'person':
      return (
        <svg className={iconClassName} fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 14a4 4 0 10-8 0m8 0a6 6 0 016 6H2a6 6 0 016-6m8-6a4 4 0 11-8 0 4 4 0 018 0z" />
        </svg>
      );
    case 'help':
      return (
        <svg className={iconClassName} fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 10a4 4 0 118 0c0 2-3 2-3 4m-.01 4h.01M12 2a10 10 0 100 20 10 10 0 000-20z" />
        </svg>
      );
    case 'contact':
      return (
        <svg className={iconClassName} fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
        </svg>
      );
    case 'settings':
      return (
        <svg className={iconClassName} fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317a1 1 0 011.35-.936l.705.387a1 1 0 00.96 0l.706-.387a1 1 0 011.35.936l.08.783a1 1 0 00.592.803l.724.313a1 1 0 01.52 1.297l-.273.744a1 1 0 000 .96l.273.744a1 1 0 01-.52 1.297l-.724.313a1 1 0 00-.592.803l-.08.783a1 1 0 01-1.35.936l-.706-.387a1 1 0 00-.96 0l-.705.387a1 1 0 01-1.35-.936l-.08-.783a1 1 0 00-.592-.803l-.724-.313a1 1 0 01-.52-1.297l.273-.744a1 1 0 000-.96l-.273-.744a1 1 0 01.52-1.297l.724-.313a1 1 0 00.592-.803l.08-.783z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15a3 3 0 100-6 3 3 0 000 6z" />
        </svg>
      );
    case 'logout':
      return (
        <svg className={iconClassName} fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H9m4 4v1a2 2 0 01-2 2H6a2 2 0 01-2-2V7a2 2 0 012-2h5a2 2 0 012 2v1" />
        </svg>
      );
    default:
      return (
        <svg className={iconClassName} fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      );
  }
};

const Sidebar = () => {
    const { user } = useAuth();
    const location = useLocation();
    const isProduction = process.env.REACT_APP_MODE === 'production';

    // Determine the single best active sidebar path (longest prefix match)
    const activeSidebarPath = (() => {
      let best = null;
      for (const item of getSidebarNavItems(user, isProduction)) {
        const p = item.path;
        if (location.pathname === p || location.pathname.startsWith(`${p}/`)) {
          if (!best || p.length > best.length) best = p;
        }
      }
      return best;
    })();

    const isItemActive = (path) => {
      if (path === '/dashboard') return location.pathname === '/dashboard';
      return activeSidebarPath === path;
    };

    const sidebarItems = getSidebarNavItems(user, isProduction);

    return (
        <aside className="hidden md:flex flex-col h-screen w-64 fixed left-0 top-0 bg-surface-container-low text-primary pb-8 border-r border-outline-variant/30 z-30">
        <div className="flex h-[72px] items-center justify-center border-b border-outline-variant/30 px-4">
          <ResponsiveLogo alt="CITNC Logo" className="h-16 w-full max-w-[360px]" />
        </div>

        <nav className="flex-1 space-y-1 overflow-y-auto custom-scrollbar px-2 pt-3">
          {sidebarItems.map((item) => (
            <Link
              key={item.name}
              to={item.path}
              className={`flex items-center pl-4 py-2.5 rounded-r-xl transition-all ${
                isItemActive(item.path)
                  ? 'text-primary font-bold border-l-4 border-tertiary-fixed bg-surface-container-high'
                  : 'text-on-surface-variant hover:bg-surface-container-high'
              }`}
            >
              <span className="mr-3">{getSidebarIcon(item.icon)}</span>
              <span className="font-body text-sm">{item.name}</span>
            </Link>
          ))}
        </nav>

      </aside>
    );
};

export default Sidebar;
